import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ConditionInfo, ModalInfo } from '../../../../shared/models';
import { ModalService } from '../../../../shared/services';

@Component({
  selector: 'app-modal-actions',
  templateUrl: './modal-actions.component.html',
  styleUrls: ['./modal-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ModalActionsComponent {
  private readonly service = inject(ModalService);

  info!: ModalInfo;
  submitBtnText: string | null = null;
  submitWithClothingBtnText: string | null = null;

  @Input('info') set setInfo(value: ModalInfo) {
    this.info = value;
    this.submitBtnText = value?.actions?.submit?.id
      ? value.actions.submit.text || this.service.getSubmitBtnText(value.actions.submit.type)
      : null;
    this.submitWithClothingBtnText = value?.actions?.submitWithClothing?.type
      ? this.service.getSubmitWithClothingBtnText(value.actions.submitWithClothing.type)
      : null;
  }

  @Input() loadingInfo: ConditionInfo = { condition: false };
  @Input() submitWithClothingContent: TemplateRef<ElementRef>;
  @Input() closeModalBtnContent: TemplateRef<ElementRef>;
  @Input() customActionBtnContent: TemplateRef<ElementRef>;
  @Input() formUnchangedInfo: ConditionInfo = { condition: false };

  @Output() closeModal = new EventEmitter<any>();
  @Output() onSubmit = new EventEmitter<null>();

  clickCloseModal(data: any = null): void {
    this.closeModal.emit(data);
  }

  clickOnSubmit(): void {
    this.onSubmit.emit(null);
  }
}
